'use strict';
import util from '../util';

function initializeEvents() {

    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        const targets = document.querySelectorAll(".cover__content_beforescroll");
        const lazyLoad = (target) => {
            var lastScrollTop = 0;
            const io = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    let animationType = $(entry.target).attr('data-animation-type');
                    let content;
                    if (animationType == "module2ScrollAnimation") {
                        content = entry.target;
                        let nextContent = entry.target.nextElementSibling;
                        let prevContent = entry.target.previousElementSibling;
                        let scrollPosition = st - $(content).parent().offset().top
                        if (scrollPosition > 0 && scrollPosition <= 60) {
                            $(content).addClass('scroll-anim');
                            $(prevContent).find('.cover_video').addClass('cover_video_scroll');
                            $(nextContent).addClass('scroll-anim');
                            $(content).show();
                        } else if (scrollPosition > 60 && scrollPosition <= 160) {
                            $(nextContent).css({ opacity: 1, 'z-index': -1 })
                            $(content).hide();
                        } else if (scrollPosition > 160 && scrollPosition <= 180) {
                            $(nextContent).css({ opacity: 1, 'z-index': 1 })
                            // $(content).hide();
                        } else if (scrollPosition > 180) {
                            $(nextContent).css({ opacity: 1, 'z-index': 2 })
                        } else if (scrollPosition <= 0) {
                            $(content).removeClass('scroll-anim');
                            $(prevContent).find('.cover_video').removeClass('cover_video_scroll');
                            $(nextContent).removeClass('scroll-anim');
                            $(nextContent).css({ opacity: 0, 'z-index': 0 })
                            $(content).show();
                        }
                    }
                    observer.disconnect();
                    lastScrollTop = st;
                })
            }, { threshold: [1] });
            io.observe(target);
        }
        targets.forEach(lazyLoad);
    });

    function initObserver(section) {
        const observerParallax = new IntersectionObserver(
            (entries) => {
                $(window).scroll(function () {
                    entries.forEach((entry) => {
                        const afterScrollContent = $(entry.target).find('.cover__content_afterscroll');
                        const coverTextContainer = $(entry.target).find('.cover-text-container');
                        const animationType = $(entry.target).find('.paraBeforeScroll').attr('data-animation-type');                     
                        const sectionTop = $(entry.target).offset().top;
                        const scrollPosition = $(window).scrollTop();
    
                        if (animationType === "module1bannerWithBackgroundParallaxEffect") {
                            $(entry.target).addClass('module1ParallaxEffect');
                            if (entry.isIntersecting && scrollPosition > sectionTop) {
                                if (!afterScrollContent.hasClass('show-content')) {
                                    afterScrollContent.addClass('show-content');
                                    coverTextContainer.stop(true, true).delay(500).queue(function (next) {
                                        $(this).addClass('fade-in');
                                        next();
                                    });
                                }
                            } else if (scrollPosition <= sectionTop) {
                                if (afterScrollContent.hasClass('show-content')) {
                                    afterScrollContent.removeClass('show-content');
                                    coverTextContainer.stop(true, true).removeClass('fade-in');
                                }
                            }
                        }
                    });
                });
            },
            {
                root: null,
                threshold: [0.2],
            }
        );
    
        observerParallax.observe(section);
    }
    
    // Initialize observer for each `experience-assets-module1and2cover` section
    $('.experience-assets-module1and2cover').each(function () {
        initObserver(this); 
    });           
}

const init = function () {
	initializeEvents();
};

export default { init };
